import { ReactNode, useEffect, useState } from "react";

import styles from "./style.module.scss";
import { BankAccountApi, BankAccountDataType } from "@/api/BankAccountApi";
import { getCurrencyCode } from "@utils/Currency";
import { BANKS } from "@utils/Constants";
import { getBankNameLabel } from "@utils/Utils";

const FooterBankAccounts = () => {

  const [bankAccounts, setBankAccounts] = useState<BankAccountDataType[]>([])

  useEffect(() => {
    loadBankAccounts()
  }, []);

  const loadBankAccounts = async () => {
    const { items: banksAccounts } = await BankAccountApi.fetchAll();
    setBankAccounts(banksAccounts)
  }

  const renderBankAccounts = (): ReactNode[] => {
    return bankAccounts.map((ba) => {
      return (<p>
        {getBankNameLabel(ba.bank_id || 0)}&nbsp;
        {getCurrencyCode(ba.moneda)}&nbsp;
        {ba.cuenta}&nbsp;
        IBAN: {ba.iban}&nbsp;

      </p>)
    });
  }

  return (
    <div className="bank-account">
      <p className="title">Cuentas Bancarias</p>
      {renderBankAccounts()}
    </div>
  );
}

export default FooterBankAccounts;
